import { useCallback, useRef, useState } from "react";
import { streamSSE } from "@/lib/api";

export function useSearchStream() {
  const [state, setState] = useState({ running: false, searchId: null, type: null, alternatives: [], total: 0, connectors: {}, results: [], error: null });
  const ctrl = useRef(null);

  const run = useCallback(async (q, { type, dossierId } = {}) => {
    ctrl.current?.abort();
    ctrl.current = new AbortController();
    setState({ running: true, searchId: null, type: null, alternatives: [], total: 0, connectors: {}, results: [], error: null });
    const p = new URLSearchParams({ q });
    if (type) p.set("type", type);
    if (dossierId) p.set("dossier_id", dossierId);
    try {
      await streamSSE(`/search/stream?${p}`, {
        signal: ctrl.current.signal,
        onEvent: (ev) => setState((s) => {
          if (ev.event === "start") return { ...s, searchId: ev.search_id, type: ev.type, alternatives: ev.alternatives, total: ev.total };
          if (ev.event === "connector")
            return { ...s, connectors: { ...s.connectors, [ev.connector]: { status: ev.status, ms: ev.ms, error: ev.error, count: ev.results.length } },
              results: [...s.results, ...ev.results] };
          if (ev.event === "done") return { ...s, running: false };
          return s;
        }),
      });
    } catch (e) {
      if (e.name !== "AbortError") setState((s) => ({ ...s, running: false, error: e.message }));
    }
    setState((s) => ({ ...s, running: false }));
  }, []);

  return [state, run, setState];
}
